<template>
  <RouterView></RouterView>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
@import './assets/css/normalize.css';
</style>

<style lang="scss">
@import './assets/css/util.scss';
.el-table thead th .cell {
  color: #333 !important;
  font-size: 16px;
}
.top-bar,
.operate,
.el-upload,
.img-container {
  > .el-button--primary.is-plain:focus,
  > .el-button--primary.is-plain:hover {
    background: #409eff !important;
    color: #fff !important;
  }
}

:global {
  html,
  body {
    height: 100%;
    font-size: 16px;
  }
  .v-modal {
    opacity: 0.35 !important;
  }
  .el-select-dropdown__item {
    font-size: 16px;
  }
  .el-card {
    border-radius: 0;
  }

  .must-check {
    color: #dd331d;
    &.no-content {
      opacity: 0;
    }
  }
  .el-pagination {
    padding: 20px 5px;
    text-align: center;
  }
  .el-button.is-round {
    padding: 8px 14px;
  }
  .el-button {
    padding: 8px 14px;
    &.el-button--warning {
      color: #fff;
      background-color: #ffb03e;
      border-color: #ffb03e;
    }
    &.el-button--primary.is-plain {
      border-color: #4b90ff;
    }
    &.el-button--warning.is-plain {
      border-color: #e6a23c;
    }
    &.el-button--info.is-plain {
      border-color: #909399;
    }
  }
  .sh-message-box {
    padding-bottom: 0;
    p {
      text-align: center;
    }
    .el-message-box__btns {
      display: none;
    }
  }
  .el-input__icon {
    line-height: inherit;
  }
}
</style>
